export const COLOR = {
  accent: '#D63B3B',
};

export const HOME = {
  city: 'Prague',
  country: 'Czechia',
  lat: 50.08,
  lon: 14.44,
  tz: 'Europe/Prague',
};
